import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import MemberService from "Lib/API/Member";
import Service from "Lib/service";
import { appContext } from "Router/routes";
import AlertDialog from "components/Dialog";
import { postalCodeLabel } from "helper/postalCodeFormat.js";
import React, { useContext, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import { DateFormetContext } from "../../../app/App.js";
import MemberTableList from "./MemberTableList";
import "./memberTablse.scss";
import SideDrawer from "../MemberDetails/EasyCare/view/profile/index.js";
import EventDrawer from "../MemberDetails/EasyCare/view/event-listing/index.jsx";
import NewTask from "../MemberDetails/EasyCare/view/new-tasks/index.jsx";

export function getMemberType(type) {
  const member_type = [
    "Member",
    "Not a member",
    "Org",
    "Resigned",
    "Business partner",
  ];
  const member_type_colors = [
    {
      color: "rgba(36, 85, 239,1)",
      background: "rgba(36, 85, 239,0.1)",
    },
    {
      color: "rgba(246, 161, 0, 1)",
      background: " rgba(246, 161, 0, 0.1)",
    },
    {
      color: "rgba(102, 102, 103, 1)",
      background: "rgba(102, 102, 103, 0.1)",
    },
    {
      color: "rgba(76, 175, 80, 1)",
      background: "rgba(76, 175, 80, 0.1)",
    },
  ];
  switch (type) {
    case 0:
      return (
        <div className="member-type" style={member_type_colors[0]}>
          {member_type[type]}
        </div>
      );
    case 1:
      return (
        <div className="member-type" style={member_type_colors[1]}>
          {member_type[type]}
        </div>
      );
    case 2:
      return (
        <div className="member-type" style={member_type_colors[2]}>
          {member_type[type]}
        </div>
      );
    case 3:
      return (
        <div className="member-type" style={member_type_colors[3]}>
          {member_type[type]}
        </div>
      );

    default:
      return (
        <div className="member-type" style={member_type_colors[0]}>
          {member_type[type]}
        </div>
      );
  }
}
const MemberTable = ({
  family_members,
  members,
  setFamilyMember,
  userFamily,
  setUserFamily,
  peoplelist,
  peopleTotalList,
  setTotalPeople,
  setPeopleList,
  isPeopleMember,
  setPeoplePage,
  peoplePage,
  openInvitationModelHandler,
  openDisableMemberUserHandler,
  peopleLoading,
  ...props
}) => {
  const orgDetails = getOrganizationInfoFromLocalStorage();
  const dateFormet = React.useContext(DateFormetContext);
  const [loading, setLoading] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [open, setOpen] = React.useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [accountAdmin, setAccountAdmin] = React.useState(false);
  const [memberToRemove, setMemberToRemove] = React.useState("");
  const [total, setTotal] = React.useState();
  const { id } = useParams();
  const [account, setAccount] = useState({});

  const [taskOpen, setTaskOpen] = useState(false);
  const [openEvent, setOpenEvent] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState({});
  const [newTaskDrawer, setNewTaskDrawer] = useState(false);

  const { getAccessTokenSilently } = useAuth0();
  const [search_item_id, setSearch_item_id] = useState(null);
  const [perPage, setPerPage] = useState(id !== undefined ? 30 : 30);
  const enableLoading = (value) => {
    setLoading(value);
  };
  const { setTypeUser } = useContext(appContext);
  const location = useLocation();
  const history = useHistory();

  const PostalLabel = postalCodeLabel();

  const getAccount = async (token) => {
    try {
      return await Service.get(
        `/accounts/contact?page=${page}&size=${30}&member=all&account=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  };

  const getPeople = async (token) => {
    try {
      return await Service.get(
        `/accounts/contact?page=${page}&size=${6}&member=${props.show}`,
        token
      );
    } catch (error) {
      throw error;
    }
  };

  const calculateProfileCompletion = (user) => {
    const {
      account,
      createdAt,
      id,
      member_id,
      profile_img,
      relationship,
      _id,
      backGround,
      account_id,
      organization,
      updatedAt,
      __v,
      ...data
    } = { ...(user ? user : {}) };
    const insertedValues = Object.values(data);
    const insertedValuesLng = insertedValues.filter((it) => {
      if (it !== "") {
        if (typeof it === "object") {
          if (it?.formattedAddress !== undefined) {
            return true;
          } else return false;
        }
        return true;
      } else return false;
    })?.length;
    return Math.round((insertedValuesLng / 23) * 100) > 100
      ? 100
      : Math.round((insertedValuesLng / 23) * 100);
  };

  const colors = ["#4CAF50", "#2A99FA"];
  useEffect(() => {
    const Qparam = new URLSearchParams(location.search).get("q");
    if (!Qparam) return;
    setSearch_item_id(Qparam);
  }, [location.search]);

  useEffect(() => {
    if (!search_item_id) return;
    fetchMyAPI();
  }, [search_item_id]);
  React.useEffect(() => {
    if (id !== undefined) {
      fetchMyAPI();
    } else {
      fetchMyAPIPeople();
    }
  }, [family_members, page, props.refresh, props.show]);

  useEffect(() => {
    isPeopleMember ? setPeoplePage(1) : setPage(1);
  }, [props.show]);

  async function fetchMyAPI() {
    setPerPage(30);
    enableLoading(true);
    const token = await getAccessTokenSilently();
    getAccount(token)
      .then((res) => {
        if (res) {
          const result = res?.contacts?.map((item) => {
            item.id = item._id;
            const random = Math.floor(Math.random() * 2);
            if (!item.profile_img) {
              item.backGround = colors[random];
            }
            item.profile_completion = calculateProfileCompletion(item);
            return item;
          });
          if (search_item_id) {
            const selected_contact = result?.filter(
              (e) => e?.id == search_item_id
            )[0];
            setAccount(selected_contact);
            setOpenDrawer(true);

            setSearch_item_id(null);
          }
          if (page === 1) setTotal(res.total);
          setList(result);
        }
        enableLoading(false);
      })
      .catch((err) => {
        enableLoading(false);
        toastr.error("Error", err?.data?.message || "Something went wrong");
      });
  }
  async function fetchMyAPIPeople() {
    setPerPage(30);
    enableLoading(true);
    const token = await getAccessTokenSilently();
    getPeople(token)
      .then((res) => {
        if (res) {
          const result = res?.contacts.map((item) => {
            item.id = item._id;
            const random = Math.floor(Math.random() * 2);
            if (!item.profile_img) {
              item.backGround = colors[random];
            }
            item.profile_completion = calculateProfileCompletion(item);
            return item;
          });

          setTotal(res.total);
          setList(result);
        }
        enableLoading(false);
      })
      .catch((err) => {
        enableLoading(false);
        toastr.error("Error", err?.data?.message || "Something went wrong");
      });
  }
  //the user should not be allowed to remove the main account admin
  const handleDelete = async () => {
    if (memberToRemove?.account_permission === "admin") {
      setOpen(false);
      return;
    } else {
      if (family_members?.length < 2) {
        setOpen(false);
      } else {
        const token = await getAccessTokenSilently();
        await MemberService.removeContact(
          { contactID: memberToRemove?._id },
          token
        )
          .then((res) => {
            if (res) {
              setOpenDrawer(false);
              setOpen(false);
              props.setRefresh(!props.refresh);
            }
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
            setOpen(false);
          });
      }
    }
  };

  const get_contact = async (id) => {
    const token = await getAccessTokenSilently();
    await AuthService.getContactById(id, token)
      .then((res) => {
        history.push(`/member-details/${id}/family-member`, res[0]);
        enableLoading(false);
      })
      .catch((err) => {
        enableLoading(false);
        toastr.error("Error", err?.data?.message || "Something went wrong");
      });
  };

  useEffect(() => {
    async function checkAccounAdmin() {
      const token = await getAccessTokenSilently();
      AuthService.getAccountById(memberToRemove?.account_id, token)
        .then((res) => {
          if (res) {
            res[0]?.main_contact?._id === memberToRemove?._id
              ? setAccountAdmin(true)
              : setAccountAdmin(false);
          }
        })
        .catch((err) => {});
    }
    if (memberToRemove?.account_id) checkAccounAdmin();
  }, [memberToRemove]);


  const openNewTaskDrawer = () => setTaskOpen(true);
  const closeNewTaskModal = () => setTaskOpen(false);


  return (
    <div className="card-group">
      <MemberTableList
        list={isPeopleMember ? peoplelist : list}
        loading={loading || peopleLoading}
        perPage={perPage}
        page={page}
        setPage={setPage}
        isPeopleMember={isPeopleMember}
        peopleTotalList={peopleTotalList}
        peoplePage={peoplePage}
        setPeoplePage={setPeoplePage}
        total={total}
        setTypeUser={setTypeUser}
        get_contact={get_contact}
        setOpen={setOpen}
        setMemberToRemove={setMemberToRemove}
        family_members={family_members}
        openInvitationModelHandler={openInvitationModelHandler}
        openDisableMemberUserHandler={openDisableMemberUserHandler}
        setAccount={setAccount}
        setOpenDrawer={setOpenDrawer}
      />
      <AlertDialog
        open={open}
        handleClose={() => setOpen(false)}
        onDecline={() => setOpen(false)}
        onAccept={handleDelete}
        title={
          memberToRemove?.account_permission === "admin"
            ? "Admin cannot be deleted"
            : family_members?.length < 2
            ? "family should have at least one member"
            : "Are you sure?"
        }
        acceptBtnText={
          memberToRemove?.account_permission === "admin" ||
          family_members?.length < 2
            ? "OK"
            : "Confirm"
        }
        description={
          memberToRemove?.account_permission === "admin"
            ? ""
            : family_members?.length < 2
            ? ""
            : "Do you want to delete this member?"
        }
      />

      {openDrawer && (
        <SideDrawer
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          account={{
            ...account,
            main_contact: {
              account_id: account?._id,
            },
          }}
          selectedData={{
            easy_contact_id: account?._id,
          }}
          handleEvent={(item) => {
            setSelectedEvent(item);
            setOpenEvent(true);
          }}
        />
      )}

      {openEvent && (
        <EventDrawer
          open={openEvent}
          onClose={() => setOpenEvent(false)}
          account={{
            main_contact: {
              account_id: account?._id,
            },
          }}
          selectedData={{
            easy_contact_id: account?._id,
            eventId: selectedEvent?.eventId,
          }}
          openNewTaskDrawer={openNewTaskDrawer}
          eventOpenData={openNewTaskDrawer}
        />
      )}
      {taskOpen && (
        <NewTask closeNewTaskModal={closeNewTaskModal} taskOpen={taskOpen} />
      )}

    </div>
  );
};

export default MemberTable;
